export default __webpack_public_path__ + "static/media/mason-jar.847f96ba.jpg";